export default {
    common: {
        home: 'Startseite',
        o_nama: 'Über uns',
        usluge: 'Leistungen',
        projekti: 'Projekte',
        nas_tim: 'Unser Team',
        karijera: 'Karriere',
        contact: 'Kontakt',
        language: 'Sprache',
        yes: 'Ja',
        no: 'Nein',
        contact_message: 'Sie können uns während der Geschäftszeiten kontaktieren oder besuchen.',
        read_more: 'Mehr erfahren',
    },

    footer: {
        description: 'Ein professionelles Elektro-Unternehmen mit langjähriger Erfahrung in der Erbringung hochwertiger Elektro-Dienstleistungen für Wohn-, Gewerbe- und Industrieobjekte.',
        contact_info: 'Kontaktinformationen',
        location: 'Slowenien / Europa',
        rights: 'Alle Rechte vorbehalten.',
        email_subject: 'Anfrage über die Webseite',
        email_body: 'Guten Tag,\n\nBitte senden Sie mir weitere Informationen.',
    },

    slogans: {
        prvi_slajd: 'MAMONT - Stärke der Zuverlässigkeit, Fachkompetenz ohne Grenzen!',
        drugi_slajd: 'Innovative Lösungen für jede elektrische Herausforderung.',
        treci_slajd: 'MAMONT – Wir bauen die Zukunft, Kabel für Kabel.',
    },

    homepage: {
        hero_eyebrow: 'Elektromontage • Industrie • Energie',
        hero_text: 'Zuverlässige Elektromontage-Lösungen für industrielle, gewerbliche und technisch anspruchsvolle Projekte in ganz Europa.',
        pogledaj_usluge: 'Leistungen ansehen',
        prijavi_se: 'Jetzt bewerben',

        zadovoljnih_klijenata: 'Zufriedene Kunden',
        projekata: 'Projekte',
        zaposlenih: 'Mitarbeiter',

        why_eyebrow: 'Warum uns wählen',
        zasto_mamont: 'Warum MAMONT?',
        why_description: 'Wir verbinden Erfahrung, qualifizierte Fachkräfte und einen verantwortungsvollen Ansatz, um jedes Projekt hochwertig, sicher und termingerecht umzusetzen.',

        reason_1_title: 'Zuverlässigkeit',
        zato_sto: 'Weil wir jedes Projekt verantwortungsvoll und präzise angehen.',
        reason_2_title: 'Loyalität',
        lojalnost: 'Wir bauen langfristige Beziehungen zu Kunden und Partnern auf.',
        reason_3_title: 'Erfahrung',
        iskustvo: 'Unser Team verfügt über Erfahrung in anspruchsvollen Elektromontage-Projekten.',
        reason_4_title: 'Fachkräfte',
        visokokvalifikovani_radnici: 'Wir verfügen über hochqualifizierte Mitarbeiter, die für anspruchsvolle Projekte bereit sind.',

        project_eyebrow: 'Arbeit vor Ort',
        svaki_projekat: 'Jedes Projekt erfordert Verantwortung, Präzision und ein Team, dem Sie vertrauen können.',
        pogledaj_projekte: 'Projekte ansehen',

        team_eyebrow: 'Unser Team',
        mamont_tim_u_akciji: 'Mamont-Team im Einsatz',
        za_nas: 'Für uns ist jedes Projekt eine Verantwortung gegenüber dem Kunden, dem Team und dem Standard, den wir aufbauen.',
        upoznaj_tim: 'Team kennenlernen',

        klijenti_od_povjerenja: 'Vertrauensvolle Kunden',
        partneri: 'Unsere Partner',
        sa_zadovoljstvom: 'Wir sind stolz darauf, Partner und Kunden hervorzuheben, die uns ihr Vertrauen geschenkt haben.',
    },

    about_us: {
        hero_title: 'Ein zuverlässiger Partner für Projekte in ganz Europa',

        mi_smo_kompanija_mamont: 'Wir sind MAMONT d.o.o., ein Synonym für Qualität, Zuverlässigkeit und Innovation im Bereich Elektroinstallationen.',
        ko_smo_mi: 'Wer wir sind',
        firma_sa_iskustvom: 'Ein Unternehmen mit langjähriger Erfahrung und hoher Qualitätsorientierung, mit Sitz in Slowenien. Unsere Leistungen erbringen wir für Kunden in ganz Europa, einschließlich Deutschland, Belgien, den Niederlanden und Italien. Unsere langjährige Tradition und Erfahrung in der Umsetzung anspruchsvoller Projekte machen uns zu einem zuverlässigen Partner in allen Bereichen der Elektroinstallation.',

        feature_1_title: 'Elektromontage',
        feature_1_text: 'Ausführung von Elektroinstallationen und Systemmontage für Industrie- und Gewerbeobjekte.',
        feature_2_title: 'Zuverlässiger Partner',
        feature_2_text: 'Langfristige Zusammenarbeit mit Kunden auf Basis von Vertrauen und Qualität.',
        feature_3_title: 'Fachkundiges Team',
        feature_3_text: 'Erfahrene Mitarbeiter, die bereit sind, an anspruchsvollen Projekten in Europa zu arbeiten.',

        projects_across_europe: 'Projekte in ganz Europa',

        misija: 'Mission',
        nasa_misija: 'Unsere Mission ist einfach — umfassende, effiziente und innovative Lösungen bereitzustellen, die die Erwartungen unserer Kunden erfüllen und übertreffen.',
        strpljiv_pristup: 'Durch einen geduldigen Ansatz, Qualitätsbewusstsein und ein Team hochqualifizierter Fachkräfte bauen wir langfristige Beziehungen zu unseren Partnern auf.',

        values_eyebrow: 'Unsere Werte',
        values_title: 'Werte, die uns leiten',
        values_description: 'Bei jedem Projekt folgen wir denselben Prinzipien: Verantwortung, Sicherheit, Präzision und Einhaltung vereinbarter Fristen.',

        value_1_title: 'Sicherheit',
        value_1_text: 'Die Sicherheit von Mitarbeitern, Kunden und Objekten hat immer Priorität.',
        value_2_title: 'Innovation',
        value_2_text: 'Wir setzen moderne Lösungen und effiziente Arbeitsmethoden ein.',
        value_3_title: 'Qualität',
        value_3_text: 'Jedes Detail muss professionell und präzise ausgeführt werden.',
        value_4_title: 'Verantwortung',
        value_4_text: 'Wir respektieren vereinbarte Fristen, Standards und die Bedürfnisse unserer Kunden.',
    },

    services: {
        nase_usluge: 'Unsere Leistungen',
        hero_title: 'Elektromontage-Lösungen für anspruchsvolle Projekte',
        navescemo_usluge: 'Im Folgenden stellen wir die wichtigsten Leistungen vor, die Mamont durch ein fachkundiges Team, Erfahrung und Arbeit an anspruchsvollen Projekten in ganz Europa anbietet.',
        posalji_upit: 'Anfrage senden',

        what_we_do: 'Was wir tun',
        services_description: 'Von der Kabelverlegung und Installation von Kabeltrassen bis hin zur Systemprüfung — wir konzentrieren uns auf Qualität, Sicherheit und präzise Ausführung.',

        service_tag_1: 'Elektromontage',
        pruzanje_kablova: 'Kabelverlegung',
        pruzanje_kablova_nacin: 'Professionelle Kabelverlegung mit Trassenplanung, präziser Arbeitsorganisation und Einhaltung technischer Standards.',

        service_tag_2: 'Qualitätskontrolle',
        testiranje_sistema: 'Systemprüfung',
        oprema_za_testiranje: 'Einsatz geeigneter Ausrüstung zur Prüfung, Kontrolle und Qualitätssicherung ausgeführter elektrischer Systeme.',

        service_tag_3: 'Installationen',
        instalacija_kanalica: 'Installation von Kabeltrassen',
        instalacija_kanalica_text: 'Montage von Elektro-Kabeltrassen und Kabelwegen für industrielle, gewerbliche und technisch anspruchsvolle Objekte.',

        zatrazi_ponudu: 'Angebot anfordern',

        process_eyebrow: 'Arbeitsweise',
        process_title: 'Von der Vereinbarung bis zur Ausführung — klar, präzise und verantwortungsvoll.',
        process_text: 'Wir betrachten jedes Projekt durch Planung, Teamorganisation, Sicherheit vor Ort und Qualität der finalen Ausführung.',

        step_1_title: 'Projektanalyse',
        step_1_text: 'Wir verstehen die Bedürfnisse des Kunden, den Arbeitsumfang und die technischen Anforderungen des Projekts.',
        step_2_title: 'Teamorganisation',
        step_2_text: 'Wir planen Mitarbeiter, Ausrüstung, Arbeitsdynamik und Sicherheitsverfahren.',
        step_3_title: 'Ausführung vor Ort',
        step_3_text: 'Wir arbeiten präzise, verantwortungsvoll und gemäß den vereinbarten Fristen.',

        cta_eyebrow: 'Benötigen Sie ein zuverlässiges Team?',
        cta_title: 'Sprechen wir über Ihr Projekt.',
        cta_text: 'Senden Sie uns eine Anfrage und wir melden uns mit Informationen zur Zusammenarbeit.',
        kontaktirajte_nas: 'Kontaktieren Sie uns',

        email_subject: 'Anfrage für Mamont-Leistungen',
        email_body: 'Guten Tag,\n\nBitte senden Sie mir weitere Informationen zu Ihren Leistungen.',
    },

    projects: {
        nasi_projekti: 'Unsere Projekte',
        hero_title: 'Projekte umgesetzt mit Präzision, Verantwortung und Erfahrung',
        nasa_firma: 'Unser Unternehmen beteiligt sich an der Realisierung von Elektromontage-Projekten für Industrie- und Gewerbeobjekte in ganz Europa.',

        gallery_eyebrow: 'Arbeitsgalerie',
        featured_projects: 'Ausgewählte Projekte',
        gallery_description: 'Werfen Sie einen Blick auf Eindrücke von Baustellen, Arbeiten und Projekten, an denen das Mamont-Team beteiligt war.',
        gallery_items: 'Fotos',
        region: 'Region',

        project_1_title: 'Industrielle Elektroinstallationen',
        project_1_text: 'Elektromontage- und Installationsarbeiten für Industrie- und Gewerbeobjekte.',

        project_2_title: 'Montage von Kabeltrassen',
        project_2_text: 'Organisierte Ausführung von Kabeltrassen, Kabelkanälen und zugehöriger elektrischer Infrastruktur.',

        project_3_title: 'Arbeiten vor Ort',
        project_3_text: 'Das Mamont-Team bei anspruchsvollen Projekten mit Fokus auf Sicherheit, Qualität und Fristen.',

        project_4_title: 'Elektromontage-Projekte',
        project_4_text: 'Ausführung von Arbeiten für Kunden durch präzise Organisation und ein fachkundiges Team.',

        project_5_title: 'Technische Ausführung',
        project_5_text: 'Arbeiten an Systemen und Installationen, die Erfahrung und Verantwortung erfordern.',

        project_6_title: 'Projekte in ganz Europa',
        project_6_text: 'Erfahrung in der Umsetzung von Projekten in Slowenien und auf dem europäischen Markt.',

        project_7_title: 'Installationen und Montage',
        project_7_text: 'Zuverlässige Ausführung von Elektroarbeiten für verschiedene Objekttypen.',

        project_8_title: 'Mamont-Team',
        project_8_text: 'Qualifizierte Fachkräfte, Teamarbeit und Organisation vor Ort.',

        project_9_title: 'Hochwertige Ausführung',
        project_9_text: 'Jedes Projekt führen wir mit Liebe zum Detail und unter Einhaltung technischer Standards aus.',

        project_10_title: 'Elektrische Systeme',
        project_10_text: 'Arbeiten an elektrischen Systemen und zugehörigen Installationen.',

        project_11_title: 'Professionelle Montage',
        project_11_text: 'Zuverlässige Montage und Ausführung von Arbeiten gemäß den Projektanforderungen.',

        project_12_title: 'Feldarbeiten',
        project_12_text: 'Praktische Projektausführung mit Erfahrung und verantwortungsvoller Organisation.',

        project_13_title: 'Installation von Kabeltrassen',
        project_13_text: 'Montage von Kabeltrassen und Kabelsystemen für Industrieobjekte.',

        project_14_title: 'Industrieanlagen',
        project_14_text: 'Arbeiten in industriellen Umgebungen mit besonderen technischen Anforderungen.',

        project_15_title: 'Elektroausrüstung',
        project_15_text: 'Arbeit mit Elektroausrüstung und Installationen bei Projekten unterschiedlicher Größenordnung.',

        project_16_title: 'Projektumsetzung',
        project_16_text: 'Von der Planung bis zur finalen Ausführung bleibt der Fokus auf Qualität und Sicherheit.',

        project_17_title: 'Komplexe Arbeiten',
        project_17_text: 'Ausführung anspruchsvoller Elektromontage-Arbeiten mit einem fachkundigen Team.',

        project_18_title: 'Mamont-Projekte',
        project_18_text: 'Ein Teil unserer ausgeführten Arbeiten und Erfahrungen vor Ort.',
    },

    tim: {
        stranica_u_pripremi: 'Seite in Vorbereitung',
        molimo_vas: 'Bitte schauen Sie später erneut vorbei. Ihr MAMONT',
    },

    career: {
        hero_eyebrow: 'Karriere',
        hero_title: 'Werden Sie Teil des Mamont-Teams',
        hero_subtitle: 'Arbeiten Sie an großen Projekten in ganz Europa',
        hero_button: 'Bewerbung senden',

        intro_eyebrow: 'Initiativbewerbungen',
        intro_title: 'Wir suchen verantwortungsbewusste Elektromonteure und Mitarbeiter, die bereit für den Einsatz vor Ort sind.',
        intro_text: 'Wenn Sie Erfahrung in Elektromontage, Installationen oder Kabeltrassen haben oder bereit sind, zu lernen und in einem starken Team zu arbeiten, senden Sie uns Ihre Bewerbung.',

        benefits: {
            projects: {
                title: 'Große Projekte',
                text: 'Arbeit an anspruchsvollen Elektromontage-Projekten in ganz Europa.',
            },
            team: {
                title: 'Stabiles Team',
                text: 'Organisierte Arbeit, klare Kommunikation und Unterstützung vor Ort.',
            },
            growth: {
                title: 'Berufliche Entwicklung',
                text: 'Möglichkeit zur Weiterentwicklung, zum Lernen und zur langfristigen Zusammenarbeit.',
            },
        },

        form_eyebrow: 'Bewerbung',
        form_title: 'Senden Sie Ihre Daten',
        form_description_no_upload: 'Füllen Sie das Formular aus und fügen Sie bei Bedarf einen Link zu Ihrem Lebenslauf oder Dokument hinzu. Unser Team wird Ihre Bewerbung prüfen und Sie kontaktieren, falls eine passende Position verfügbar ist.',

        note_title: 'Hinweis',
        note_text: 'Mit einem Sternchen gekennzeichnete Felder sind Pflichtfelder.',

        email: {
            subject: 'Neue Bewerbung - Mamont',
        },

        fields: {
            full_name: 'Vor- und Nachname',
            email: 'E-Mail-Adresse',
            phone: 'Telefon',
            location: 'Wohnort',
            position: 'Position, für die Sie sich bewerben',
            experience: 'Jahre Berufserfahrung',
            availability: 'Verfügbarkeit für Arbeitsbeginn',
            eu_citizen: 'Sind Sie EU-Bürger',
            eu_citizen_confirm: 'Ja, ich bin EU-Bürger',
            message: 'Berufserfahrung / kurze Nachricht',
            cv_upload: 'Lebenslauf / Dokument',
            privacy_consent: 'Ich stimme zu, dass Mamont meine Daten zum Zweck der Bewerbung verarbeitet.',
        },

        placeholders: {
            full_name: 'Geben Sie Ihren Vor- und Nachnamen ein',
            email: "name{'@'}email.com",
            phone: '+387 / +386 / +49',
            location: 'Stadt / Land',
            position: 'Position auswählen',
            experience: 'Erfahrung auswählen',
            availability: 'Sofort / in 15 Tagen / nach Vereinbarung',
            message: 'Beschreiben Sie kurz Ihre Erfahrung, Fähigkeiten und Verfügbarkeit.',
        },

        positions: {
            electro_installer: 'Elektromonteur',
            assistant_worker: 'Hilfsarbeiter',
            team_lead: 'Teamleiter / Vorarbeiter',
            other: 'Sonstiges',
        },

        experience: {
            no_experience: 'Keine Erfahrung',
            one_two: '1–2 Jahre',
            three_five: '3–5 Jahre',
            five_plus: '5+ Jahre',
        },

        file: {
            empty: 'PDF-, DOC- oder DOCX-Dokument hinzufügen',
            limit: 'Die maximale Dokumentgröße beträgt 10 MB.',
        },

        submit: {
            default: 'Bewerbung senden',
            loading: 'Wird gesendet...',
        },

        success: 'Ihre Bewerbung wurde erfolgreich gesendet. Vielen Dank für Ihr Interesse.',

        errors: {
            file_type: 'Es sind nur PDF-, DOC- und DOCX-Dokumente erlaubt.',
            file_size: 'Das Dokument darf nicht größer als 10 MB sein.',
            privacy_required: 'Sie müssen der Datenverarbeitung zustimmen.',
            generic: 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
        },
    },
};